<template>
  <MapWidget
    class="best-addresses-widget"
    :title="$t('message.dashboard.widgetTitle.bestGmbAddresses')"
    :tooltip="$t('message.dashboard.widgetTooltip.bestGmbAddresses')"
    :data="data"
    :action-handler="actionHandler"
    :loading="loading"
  >
    <template v-slot="item">
      <div class="rating-row" v-if="item.reviews_rating !== null">
        <StarsRating :rating="item.reviews_rating" />

        <div class="rating-value">
          {{ item.reviews_rating.toString().replace(".", ",") }}
        </div>
        <ui-button
          transparent
          small
          class="ml-auto"
          :to="{
            name: 'reviews-list',
            query: { ids: `${item.gmb_address_id}` }
          }"
          @click.native="handleClick(item.gmb_address_id)"
        >
          {{ $t("message.common.more") }}
        </ui-button>
      </div>
      <div></div>
    </template>
  </MapWidget>
</template>

<script>
import MapWidget from "@/components/Dashboard/base/MapWidget";
import StarsRating from "@/components/ui/StarsRating";

import { dashboardWidget } from "@/helpers/mixins/dashboard-widget";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "DashboardBestAddressesWidget",
  components: {
    MapWidget,
    StarsRating
  },
  mixins: [dashboardWidget],
  methods: {
    handleClick(id) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.DASHBOARD_SHOW_DETAILS,
        component: "highest_rated_locations",
        location_id: id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  .rating-value {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: $spacing;
    padding-top: 3px;
  }
}
</style>

<style lang="scss">
.best-addresses-widget {
  .map-widget-marker {
    color: $dashboard-positive-color !important;
  }
}

.v-btn:not(.v-btn--round).v-size--small {
  height: 26px;
}
</style>
